<template>
  <div class="banner">
    {{ titulo }}
  </div>
</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  background-color: $azulClaroMMT;
  color: white;
  font-weight: 500;
  font-size: 150%;
  padding: 0.4em;
  display: flex;
}
</style>
